import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';


@Component({
    name: 'ed-password-progress-bar'
})

export default class EdPasswordProgressBar extends Vue {
    public validators: any;
    public colors:any = {
        color1: '#e71837',
        color2: '#f5291d',
        color3: '#ffae42',
        color4: '#fce903',
        color5: '#49b675',
    }
    public passStrength:number = 0;
    @Prop() readonly password: string;
    @Prop() readonly watchPassValidators: any;

    public animateInnerBar(count:number){
        let bar:any = document.getElementById('inner-bar');
        bar.style.width = (20*count)+'%';
        bar.style.backgroundColor = this.colors['color'+count];
        if(count<3)
            this.passStrength = 0
        else if(count<5)
            this.passStrength = 1
        else 
            this.passStrength = 2
    }

    public showText(key:string,password:string){
        if(key == 'noSpace'){
            return this.validators[key].regex.test(password);
        }
        if(this.validators[key].regex.test(password) || password=='')
            return false;
        else
            return true;

    }

    public created(){
        this.validators = {
            minLength:      { valid:false , text:this.$i18n.t('auth.progressBar.minLength'), regex:/.{8,}/ },
            oneUppercase:   { valid:false , text:this.$i18n.t('auth.progressBar.oneUppercase'), regex:/[A-Z]/ },
            oneLowercase:   { valid:false , text:this.$i18n.t('auth.progressBar.oneLowercase'), regex:/[a-z]/ },
            oneNumber:      { valid:false , text:this.$i18n.t('auth.progressBar.oneNumber'), regex:/[0-9]/ },
            specialChar:    { valid:false , text:this.$i18n.t('auth.progressBar.specialChar'), regex:/[!@#$%^&*?_~\\\-'()+.,":;<=>\][`{}|/]/ },
            noSpace:        { valid:true ,  text:this.$i18n.t('auth.progressBar.noSpace'), regex:/[\s]/ }
        }
    }

    @Watch('password')
    validate(password: any) {
        let count = 0;
        for(let key in this.validators){
            if(key != 'noSpace'){
                if(this.validators[key].regex.test(password))
                    count++
            }
        }
        if(this.validators.noSpace.regex.test(password)){
            count = 0;
        }
        if(count==5){
            this.$emit('watchPassValidators',true);
        }
        else{
            this.$emit('watchPassValidators',false);
        }
        this.animateInnerBar(count);
    }
}